import { ChartProcessorContext, isVegaLiteSpec } from './index';

export function processLineChart({ spec, isBig }: ChartProcessorContext) {
    const newSpec = { ...spec };

    if (isVegaLiteSpec(newSpec)) {
        const encoding = (newSpec as any).encoding || {};
        const yField = encoding.y?.field;
        const yType = encoding.y?.type || 'quantitative';
        const yTitle = encoding.y?.axis?.title || encoding.y?.title || yField;

        if (yField && yType === 'quantitative') {
            const tooltipItems: any[] = [];

            const colorField = encoding.color?.field;
            if (colorField && colorField !== '__color_patch__') {
                tooltipItems.push({
                    field: colorField,
                    type: encoding.color.type || 'nominal',
                    title: encoding.color.legend?.title || colorField,
                });

                encoding.color.legend = null;
            }

            if (encoding.x?.field) {
                tooltipItems.push({
                    field: encoding.x.field,
                    type: encoding.x.type || 'temporal',
                    title: encoding.x.axis?.title || encoding.x.title || encoding.x.field,
                });
            }

            tooltipItems.push({
                field: 'label',
                type: 'nominal',
                title: yTitle,
            });

            encoding.tooltip = tooltipItems;
            (newSpec as any).encoding = encoding;
            (newSpec as any).mark = {
                ...(newSpec as any).mark,
                point: true,
            };
        }

        if (isBig) {
            newSpec.autosize = {
                type: 'pad',
                contains: 'padding',
                resize: true,
            };
            (newSpec as any).height = 500;
        }
    }

    return newSpec;
}
